export const TASK = "TASK";
export const NOTE = "NOTE";

export const SEARCH_TYPE_WHO = "WHO";
export const SEARCH_TYPE_WHAT = "WHAT";
export const SEARCH_TYPE_PARENT = "PARENT";
